<template>
	<div class="priced-item">
		<div class="title">{{ title }}</div>
		<AnimatedNumber class="amount" :number="amount" :filters="'currency'" />
		<div class="progress-wrapper">
			Paid <AnimatedNumber class="paid" :number="paid" :filters="'currency'" />
			of <AnimatedNumber class="total" :number="amount" :filters="'currency'" />
		</div>
	</div>
</template>

<script>
import AnimatedNumber from "@/components/base/AnimatedNumber";

export default {
	name: 'PricedItem',
	components: {
		AnimatedNumber,
	},
	props: {
		amount: {
			type: Number,
			required: true,
		},
		paid: {
			type: Number,
			required: false,
			default: 0,
		},
		title: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.priced-item {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: baseline;
		width: 100%;
		color: white;

		&::after {
			content: "";
			border-bottom: dotted .25ch white;
			flex: 1;
			order: 1;
		}
	}

	.title { margin-right: .5ex; }

	.amount {
		margin-left: .5ex;
		order: 2;

		.priced-item.show-progress & {
			display: none;
		}
	}

	.progress-wrapper {
		display: none;

		.priced-item.show-progress & {
			display: inline-block;
			margin-left: .5ex;
			order: 2;
		}
	}
</style>
